import {
  Component, DoCheck, EventEmitter, Input, IterableDiffer, IterableDiffers, OnInit, Output
} from '@angular/core';
import { AnalysisImage } from '@app/@shared/models/reverse-engineering/analysis.models';
import { BaseAnalysisImagesViewDirective } from '../base-analysis-images-view/base-analysis-images-view.directive';
import { FeatureFlagService } from '@app/@shared/services/featureflag.service';
import { environment } from '@env/environment';

@Component({
    selector: 'app-image-grid-view',
    templateUrl: './image-grid-view.component.html',
    styleUrls: ['./image-grid-view.component.scss'],
    standalone: false
})
export class ImageGridViewComponent extends BaseAnalysisImagesViewDirective implements OnInit, DoCheck {
  @Input() downloadEnabled = false;
  @Output() downloadImage = new EventEmitter<AnalysisImage>();

  public iterableDiffer: IterableDiffer<AnalysisImage>;

  constructor(
    private _iterableDiffers: IterableDiffers,
    protected ffService: FeatureFlagService,
  ) {
    super();
    this.iterableDiffer = _iterableDiffers.find(this.images).create();
  }

  public ngDoCheck(): void {
    const changes = this.iterableDiffer.diff(this.images);
    if (changes) {
      this.updateSelectedImages();
    }
    if (this.selectedImages.selectedImagesQty && changes) {
      for (const image of this.images) {
        for (const someImage of this.selectedImages.allImages) {
          if (image.id === someImage.id) {
            image.selected = someImage.selected;
          }
        }
      }
    }
  }

  public ngOnInit(): void {
    this.updateSelectedImages();
    this.images?.forEach((image) => {
      image.selected = false;
    });
  }

  public clickSelectImage(image: AnalysisImage): void {
    image.selected = !image.selected;
    this.selectedImages.allImages.forEach((selectedImage) => {
      if (image.id === selectedImage.id) {
        selectedImage.selected = image.selected;
      }
    });
    this.countImages(image.selected);
    this.updateSelectAll();
    this.updateSelectedImages();
  }

  public clickSelectAll(allSelected: boolean = !this.selectedImages.allSelected): void {
    this.selectedImages.allSelected = allSelected;
    this.images.forEach((image) => {
      image.selected = this.selectedImages.allSelected;
    });
    this.selectedImages.allImages.forEach((image) => {
      image.selected = this.selectedImages.allSelected;
    });
    if (!this.selectedImages.allSelected) {
      this.selectedImages.selectedImagesQty = this.images.filter((image) => image.selected === true).length;
    }
    this.updateSelectedImages();
  }

  public clickDownloadImage(image: AnalysisImage): void {
    this.downloadImage.emit(image);
  }

  private countImages(selected: boolean) {
    if (this.selectedImages.selectedImagesQty === this.imageCount && !selected) {
      this.selectedImages.selectedImagesQty = this.images.filter((image) => image.selected === true).length;
    } else if (this.imageCount !== this.selectedImages.selectedImagesQty && !selected) {
      --this.selectedImages.selectedImagesQty;
    } else {
      ++this.selectedImages.selectedImagesQty;
    }
  }

  private updateSelectAll(): void {
    if (this.selectedImages.selectedImagesQty !== this.imageCount) {
      this.selectedImages.allSelected = false;
    }
    if (this.images.filter((image) => image.selected).length !== this.images.length) {
      this.selectedImages.allSelected = false;
    }
  }

}
